'use client';

import { ChakraProvider } from '@chakra-ui/react';
import { IS_STORYBOOK } from '@m/constants/FeatureFlags';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';
import { system } from './theme';
import { Toaster } from './toaster';

export const metropolitanQueryClient = new QueryClient();

export function Provider(props: ColorModeProviderProps) {
  return (
    <QueryClientProvider client={metropolitanQueryClient}>
      {!IS_STORYBOOK && <ReactQueryDevtools initialIsOpen={false} />}
      <ChakraProvider value={system}>
        <ColorModeProvider {...props} />
        <Toaster />
      </ChakraProvider>
    </QueryClientProvider>
  );
}
